import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface TypeDocument {
  name: string;
  api_token: string;
}

export interface TypeDocumentDetaiInfor {
  errors: unknown;
  TypeDocument: TypeDocument;
  isAuthenticated: boolean;
}

@Module
export default class TypeDocumentDetail
  extends VuexModule
  implements TypeDocumentDetaiInfor
{
  errors = {};
  TypeDocument = {} as TypeDocument;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get TypeDocumentDetail() {
    return this.typeDocumentDetailData;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.TYPE_DOCUMENT_DETAIL_DATA](TypeDocument) {
    this.typeDocumentDetailData = TypeDocument;
  }
  @Action
  [Actions.TYPE_DOCUMENT_DETAIL](payload) {
    return ApiService.getDataDetail(
      "/type_documents",
      payload,
      "detail",
      payload
    )
      .then(({ data }) => {
        this.context.commit(Mutations.TYPE_DOCUMENT_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
